import React from 'react'
import styled from 'styled-components'

const ProgressIndicatorContainer = styled.div`
  min-height: 3px;
  background-color: ${(props) => props.theme.palette.neutral.default.five};
  position: relative;
`

const ProgressIndicator = styled.div`
  background-color: ${(props) =>
    props.theme.palette.highlight.primary.normalBackground};
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  transition: all 0.2s ease-out;
`

interface Props {
  percentage: number
}

function ProgressBar({ percentage }: Props) {
  return (
    <ProgressIndicatorContainer>
      <ProgressIndicator style={{ width: `${percentage}%` }} />
    </ProgressIndicatorContainer>
  )
}

export default ProgressBar
